import { lazy } from 'react';

const LazyClientSpace = lazy(() => import('./client-space'));
export default LazyClientSpace;
